module.exports = __webpack_public_path__ + "img/img3.fd33ae87.png";